import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components'

import colors from '../theme/colors'
import * as _colors from '../theme/_colors'
import mapProps from '../theme/mapProps'
import {
  Headline,
  ViewportRow,
  ContentRow,
  ViewportContainer,
  PageContainer,
  Container,
  Block,
  Fill,
  Title,
  Flex,
} from '../styleguide'

export default props => (
  <div>
    <ContentRow>
      <Container py="3">
        <Flex row="wrap">
          <CTAContainer mb="3">
            <h1>Know what you’re building.</h1>
            <Title weight="light" lines={1.5}>
              Use natural language to design, define, and model your requirements
            </Title>
          </CTAContainer>
          <Fill scale={2} />
          <Form>
            <Label>
              Enter your email
              <Email />
            </Label>
            <Fill scale={2} />
            <Button>Subscribe</Button>
          </Form>
        </Flex>
      </Container>
    </ContentRow>
    <ContentRow color={colors.gray[1]} background={colors.indigo[6]}>
      <h2>Know your requirements</h2>
      <p>Understanding what to build starts with good requirements — REQS makes it easy. </p>
      <p>
        REQS is a collaborative tool for <b>Requirements Development and Analysis</b>. Leveraging natural
        language analysis it provides a workflow with structure and intelligence.
      </p>
    </ContentRow>
    <ContentRow>
      <h2>Work your way down</h2>
      <p>
        Translate your high-level requirements into low-level contraints. Each time you add a sub-requirement
        you add a new layer of detail constraining the possible designs and solutions.
      </p>
      <p>When you use sub-requirements with REQS you have traceability.</p>
    </ContentRow>
    <ContentRow color={colors.gray[2]} background={colors.gray[9]}>
      <h2>Drawn from industry standards</h2>
      <p>
        REQS employs ideas from architecture and object oriented analysis to provide a simple structured
        approach.
      </p>
      <p>
        And, by using semantic technologies, REQS has the capability to reason about your requirements and
        identify mistakes.
      </p>
      <p>Taken together your work is easier, more complete, and more collaborative.</p>
    </ContentRow>
  </div>
)

const Form = styled.div`
  display: flex;
  align-items: center;

  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 .1875rem 0 #e6ebf1;
`
const Label = styled.label`
  color: #6b7c93;
  font-weight: 300;
  letter-spacing: 0.025em;
`
const Email = styled.input.attrs({ type: 'text', placeholder: 'tom@jerry.com' })`
  color: '#424770';
  font-size: 1.5rem;
  line-height: 2rem;
  letter-spacing: '0.025em';
  ::placeholder {
    color: #aab7c4;
  }

  display: block;
  margin: .625rem 0 1.25rem 0;
  max-width: 30rem;
  padding: .625rem .875rem;
  box-shadow: rgba(50, 50, 93, 0.14902) 0 .0625rem .1875rem, rgba(0, 0, 0, 0.0196078) 0 .0625rem 0;
  border-radius: .25rem;
  background: white;

  transition: all 150ms ease;
  &:hover {
    ${'' /* box-shadow:
      rgba(50, 50, 93, 0.109804) 0 .125rem .0625rem,
      rgba(0, 0, 0, 0.0784314) 0 0 .0625rem
    ; */};
    box-shadow: rgba(50, 50, 93, 0.109804) 0 .25rem .375rem, rgba(0, 0, 0, 0.0784314) 0 .0625rem .1875rem;
    transition: all 150ms ease;
  }
  &:focus {
    ${'' /* box-shadow:
      rgba(50, 50, 93, 0.109804) 0 .25rem .375rem,
      rgba(0, 0, 0, 0.0784314) 0 .0625rem .1875rem
    ; */};
    box-shadow: 0 .4375rem .875rem rgba(50, 50, 93, 0.1), 0 .1875rem .375rem rgba(0, 0, 0, 0.08);
    transition: all 150ms ease;
  }
`

const Button = styled.button`
  white-space: nowrap;
  border: 0;
  outline: 0;
  display: inline-block;
  height: 2.5rem;
  line-height: 2.5rem;
  padding: 0 .875rem;
  box-shadow: 0 .25rem .375rem rgba(50, 50, 93, 0.11), 0 .0625rem .1875rem rgba(0, 0, 0, 0.08);
  color: #fff;
  border-radius: .25rem;
  font-size: .9375rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  background-color: ${colors.indigo[6]};
  text-decoration: none;
  transition: all 150ms ease;
  margin-top: 0.75rem;
  &:hover {
    color: #fff;
    cursor: pointer;
    background-color: #7795f8;
    transform: translateY(-.0625rem);
    box-shadow: 0 .4375rem .875rem rgba(50, 50, 93, 0.1), 0 .1875rem .375rem rgba(0, 0, 0, 0.08);
  }
  &:active {
    color: #fff;
    cursor: pointer;
    background-color: ${colors.indigo[8]};
    transform: translateY(.0625rem);
    box-shadow: 0 .1875rem .3125rem rgba(50, 50, 93, 0.1), 0 0 .0625rem rgba(0, 0, 0, 0.08);
  }
`

const CTAContainer = styled(Container)`
  max-width: 30rem;
  margin-left: 0;
`



// WEBPACK FOOTER //
// ./src/pages/index.js